import { get, post, put } from "../../../services/request";

//-------------------Region----------------//
// Get all regions
export const getAllRegions = () => {
  return get("Region/GetAllRegion");
};

// Get region by ID
export const getRegionById = (regionId) => {
  return get(`Region/GetRegionByID?RegionID=${regionId}`);
};

// Save region (create new region)
export const saveRegion = (regionData) => {
  return post("Region/SaveRegion", regionData);
};

// Create region
export const createRegion = (regionData) => {
  return post("Region/CreateRegion", regionData);
};

// Update region
export const updateRegion = (regionData) => {
  return put(`Region/UpdateRegion`, regionData);
};

// Delete region
export const deleteRegion = (regionId, modifiedBy) => {
  return post("Region/DeleteRegion", {
    RegionID: regionId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate region
export const activateDeactivateRegion = (regionId, status, userId) => {
  return post("Region/ActivateDeactivate", {
    Id: regionId,
    Status: status,
    UserId: userId,
  });
};

//-------------------National----------------//
// Get all nationals
export const getAllNationals = () => {
  return get("National/GetAllNational");
};

// Get national by ID
export const getNationalById = (nationalId) => {
  return get(`National/GetNationalByID?NationalID=${nationalId}`);
};

// Save national (create/update national)
export const saveNational = (nationalData) => {
  return post("National/SaveNational", nationalData);
};

// Delete national
export const deleteNational = (nationalId, modifiedBy) => {
  return post("National/DeleteNational", {
    NationalID: nationalId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate national
export const activateDeactivateNational = (nationalId, status, userId) => {
  return post("National/ActiveDeactiveNational", {
    Id: nationalId,
    Status: status,
    UserId: userId,
  });
};

//-------------------RPCE----------------//
// Get all RPCE
export const getAllRPCE = () => {
  return get("RPCE/GetAllRPCE");
};

// Get RPCE by ID
export const getRPCEById = (rpceId) => {
  return get(`RPCE/GetRPCEByID?RPCEID=${rpceId}`);
};

// Save RPCE (create new RPCE)
export const saveRPCE = (rpceData) => {
  return post("RPCE/SaveRPCE", rpceData);
};

// Create RPCE
export const createRPCE = (rpceData) => {
  return post("RPCE/CreateRPCE", rpceData);
};

// Delete RPCE
export const deleteRPCE = (rpceId, modifiedBy) => {
  return post("RPCE/DeleteRPCE", {
    RPCEID: rpceId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate RPCE
export const activateDeactivateRPCE = (rpceId, status, userId) => {
  return post("RPCE/ActivateDeactivate", {
    Id: rpceId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Worklist----------------//
// Get worklist dropdown
export const getWorklistDropdown = () => {
  return get("WorkList/GetAllRPCEDropdown");
};

// Get worklist
export const getworklist = () => {
  return get("WorkList/GetAllWorkList");
};

// Delete worklist
export const deleteWorklist = (worklistId, modifiedBy) => {
  return post("WorkList/DeleteWorkList", {
    worklistID: worklistId,
    modifiedBy: modifiedBy,
  });
};

// Save workList (create new worklist)
export const saveWorklist = (worklistData) => {
  return post("WorkList/SaveWorkList", worklistData);
};

// Update workList
export const getWorklistById = (worklistId) => {
  return get(`WorkList/GetWorkListByID?WorkListID=${worklistId}`);
};

// Activate/Deactivate workList
export const activateDeactivateWorklist = (worklistId, status, userId) => {
  return post("Worklist/ActivateDeactivate", {
    Id: worklistId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Worklist Definition----------------//
export const getAllWorklistDefinition = (filters = null) => {
  return post("WorklistDefinition/GetAllWorklist", filters || {});
};

export const getWorklistDefinitionTypeDropdown = () => {
  return get("WorklistDefinition/GetWorklistType");
};

export const getWorklistDefinitionFacilityDropdown = () => {
  return get("WorklistDefinition/GetMappedSitesDropDownList");
};

export const saveWorklistDefinition = (worklistDefinitionData) => {
  return post("WorklistDefinition/SaveWorklist", worklistDefinitionData);
};

export const deleteWorklistDefinition = (workListId, modifiedBy) => {
  return post("WorklistDefinition/DeleteWorklist", {
    WorkListID: workListId,
    ModifiedBy: modifiedBy,
  });
};

export const activateDeactivateWorklistDefinition = (
  workListId,
  status,
  userId,
) => {
  return post("WorklistDefinition/ActivateDeactivate", {
    Id: workListId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Worklist Group----------------//
export const getAllWorklistGroup = () => {
  return get("WorklistGroup/GetAllWorklistGroup");
};

export const getWorklistGroupWorklistDropdown = (worklistGroupId = 0) => {
  return get(
    `WorklistGroup/GetAvailableWorklistDropDown?worklistGroupId=${worklistGroupId || 0}`,
  );
};

export const saveWorklistGroup = (worklistGroupData) => {
  return post("WorklistGroup/SaveWorklistGroup", worklistGroupData);
};

export const deleteWorklistGroup = (worklistGroupId, modifiedBy) => {
  return post("WorklistGroup/DeleteWorklistGroup", {
    WorklistGroupID: worklistGroupId,
    ModifiedBy: modifiedBy,
  });
};

export const activateDeactivateWorklistGroup = (
  worklistGroupId,
  status,
  userId,
) => {
  return post("WorklistGroup/ActivateDeactivate", {
    Id: worklistGroupId,
    Status: status,
    UserId: userId,
  });
};

export const getWorklistDefinitionConfigurationList = (filters) => {
  return post(
    "WorklistDefinitionConfiguration/GetWorklistConfigurationList",
    filters || {},
  );
};

export const getWorklistDefinitionConfigurationDropdowns = (
  workListDefinationID,
  workListDefinationSiteMappingId = 0,
) => {
  return get(
    `WorklistDefinitionConfiguration/GetWorklistConfigurationDropdowns?workListDefinationID=${workListDefinationID}&workListDefinationSiteMappingId=${workListDefinationSiteMappingId}`,
  );
};

export const checkWorklistDefinitionConfigurationFacilityAvailability = (
  payload,
) => {
  return post(
    "WorklistDefinitionConfiguration/CheckFacilityAlreadyAvailable",
    payload,
  );
};

export const getWorklistDefinitionConfigurationById = (
  workListDefinationSiteMappingId,
) => {
  return get(
    `WorklistDefinitionConfiguration/GetWorklistConfigurationById?workListDefinationSiteMappingId=${workListDefinationSiteMappingId}`,
  );
};

export const saveWorklistDefinitionConfiguration = (data) => {
  return post("WorklistDefinitionConfiguration/SaveWorklistConfiguration", data);
};

export const deleteWorklistDefinitionConfiguration = (
  workListDefinationSiteMappingId,
) => {
  return post("WorklistDefinitionConfiguration/DeleteWorklistConfiguration", {
    WorkListDefinationSiteMappingId: workListDefinationSiteMappingId,
  });
};

export const activateDeactivateWorklistDefinitionConfiguration = (
  workListDefinationSiteMappingId,
  status,
  userId,
) => {
  return post(
    "WorklistDefinitionConfiguration/ActivateDeactivateWorklistConfiguration",
    {
      Id: workListDefinationSiteMappingId,
      Status: status,
      UserId: userId,
    },
  );
};

export const getAllTagCategoryConfiguration = (filters = null) => {
  return post(
    "TagCategoryConfiguration/GetAllTagCategoryConfiguration",
    filters || {},
  );
};

export const getTagCategoryConfigurationById = (tagCategoryID) => {
  return get(
    `TagCategoryConfiguration/GetTagCategoryConfigurationByID?tagCategoryID=${tagCategoryID}`,
  );
};

export const saveTagCategoryConfiguration = (data) => {
  return post("TagCategoryConfiguration/SaveTagCategoryConfiguration", data);
};

export const activateDeactivateTagCategoryConfiguration = (
  tagCategoryID,
  status,
  userId,
) => {
  return post("TagCategoryConfiguration/ActivateDeactivate", {
    Id: tagCategoryID,
    Status: status,
    UserId: userId,
  });
};

export const getManageTagsShell = (tagCategoryID) => {
  return get(`Tag/GetTagsAndModulesByCategory?tagCategoryID=${tagCategoryID}`);
};

export const getTagAssignments = (model) => {
  return post("Tag/GetAssignedEntities", model);
};

export const saveManageTagsBatch = (data) => {
  return post("Tag/SaveManageTagsBatch", data);
};

export const saveTag = (data) => {
  return post("Tag/SaveTag", data);
};

export const deleteTag = (data) => {
  return post("Tag/DeleteTag", data);
};

//-------------dropdowns in Worklist start ----------------

//// All master worklist dropdowns
export const getAllMasterWorklistDropdowns = () => {
  return get("Worklist/GetAllMasterWorklistDropDowns");
};

// Get Regional Practice Worklist dropdown
export const getRegionalPracticeWorklistDropdown = (regionalPracticeID) => {
  const query = regionalPracticeID
    ? `?regionalPracticeID=${regionalPracticeID}`
    : "";
  return get(
    `AdvancedSchedulingCommon/GetAllRegionPracticeWorklist_DD${query}`,
  );
};

//Main Practice
export const getMainPracticeDropdown = (regionalPracticeID) => {
  const query = regionalPracticeID
    ? `?regionalPracticeID=${regionalPracticeID}`
    : "";
  return get(`AdvancedSchedulingCommon/GetAllMainPractice_DD${query}`);
};

//-------------dropdowns in Worklist end ----------------

//-------------------Practice----------------//
// Get all Practice
export const getAllPractice = () => {
  return get("Practice/GetAllPractice");
};

// Get workList dropdown
export const getAllWorklistDropdown = () => {
  return get("Common/GetWorkList");
};

// Get region workList by id
export const getRegionByWorklistID = (id) => {
  return get(`Practice/GetRegionByWorklist?id=${id}`);
};

// Get all master regions dropdown
export const getAllMasterRegionDropdown = () => {
  return get("AdvancedSchedulingCommon/GetAllMasterRegion_DD");
};

// Get all master nationals dropdown
export const getAllMasterNationalDropdown = () => {
  return get("AdvancedSchedulingCommon/GetAllMasterNational_DD");
};

// Save practice
export const savePractice = (practiceData) => {
  return post("Practice/SavePractice", practiceData);
};

//get practice
export const getpracticeById = (practiceId) => {
  return get(`Practice/GetPracticeByID?PracticeID=${practiceId}`);
};

// Delete Practice
export const deletePractice = (practiceId, modifiedBy) => {
  return post("Practice/DeletePractice", {
    PracticeID: practiceId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate Practice
export const activateDeactivatePractice = (PracticeID, status, userId) => {
  return post("Practice/ActivateDeactivate", {
    Id: PracticeID,
    Status: status,
    UserId: userId,
  });
};

//-------------------SubPractice----------------//
// Get all subpractices
export const getAllSubpractice = () => {
  return get("SubPractice/GetAllSubPractice");
};

// Delete subpractice
export const deleteSubpractice = (subpracticeId, modifiedBy) => {
  return post("SubPractice/DeleteSubPractice", {
    SubPracticeID: subpracticeId,
    ModifiedBy: modifiedBy,
  });
};

//save subpractice
export const saveSubpractice = (subpracticeData) => {
  return post("SubPractice/SaveSubPractice", subpracticeData);
};

// Update subpractice
export const getSubpracticeById = (subpracticeId) => {
  return get(`SubPractice/GetSubPracticeByID?SubPracticeID=${subpracticeId}`);
};

// Activate/Deactivate subpractice
export const activateDeactivateSubpractice = (
  subpracticeId,
  status,
  userId,
) => {
  return post("SubPractice/ActivateDeactivate", {
    Id: subpracticeId,
    Status: status,
    UserId: userId,
  });
};

// Get subpractice dropdown
export const getSubpracticeDropdown = () => {
  return get("Practice/GetAllPractice");
};

//-------------------SectionWorklist Mapping----------------//
// Get all section worklists
export const getAllSectionWorklist = () => {
  return get("RadSection/GetAllRadSection");
};

// Delete section worklist
export const deleteSectionWorklist = (SectionID, modifiedBy) => {
  return post("RadSection/DeleteRadSection", {
    SectionID: SectionID,
    ModifiedBy: modifiedBy,
  });
};

//save section worklist
export const saveSectionWorklist = (sectionWorklistData) => {
  return post("RadSection/SaveRadSection", sectionWorklistData);
};

// Update section worklist
export const getSectionWorklistById = (sectionWorklistId) => {
  return get(`RadSection/GetRadSectionByID?SectionID=${sectionWorklistId}`);
};

// Activate/Deactivate section worklist
export const activateDeactivateSectionWorklist = (
  SectionID,
  status,
  userId,
) => {
  return post("RadSection/ActivateDeactivate", {
    Id: SectionID,
    Status: status,
    UserId: userId,
  });
};

// //-------------------User Management - start------------------//
// // Get all User Management
// export const getAllUserManagement = () => {
//     return get('RadUser/GetAllRadUser');
// };

// // delete User Management
// export const deleteUserManagement = (UserId, modifiedBy) => {
//     return post('RadUser/DeleteRadUser', {
//         UserId: UserId,
//         ModifiedBy: modifiedBy
//     });
// };

// // Get section worklist dropdown
// export const getSectionWorklistDropdown = () => {
//     return get('Common/GetWorkList');
// };

// // Save User Management (Add/Update)
// export const saveUserManagement = (userData) => {
//     return post('User/SyncSaveUserDetails', userData);
// };

// // Activate/Deactivate User Management
// export const activateDeactivateUserManagement = (userId, status, modifiedBy) => {
//     return post('RadUser/ActivateDeactivate', {
//         Id: userId,
//         Status: status,
//         UserId: modifiedBy
//     });
// };

// // Export User Management to CSV
// export const exportUserManagementToCSV = () => {
//     return get('RadUser/ExportToCSV');
// };

// // Get user management dropdown
// export const getUserManagementRoleDropdown = () => {
//     return get('AdvancedSchedulingCommon/GetAllMasterUserRoles_Dropdown');
// };

// // Get user management dropdown
// export const getUserManagementDesignationDropdown = () => {
//     return get('RadUserRole/GetAllRadUserRole');
// };

// // Update usermanagement
// export const getUSerManagementById = (userId) => {
//     return get(`RadUser/GetRadUserByID?RadUserID=${userId}`);
// }

// // Get all Master Tenants dropdown
// export const getAllMasterTenantsDropdown = () => {
//     return get('AdvancedSchedulingCommon/GetAllMasterTenants_Dropdown');
// };

// // Get User Regional Practice dropdown
// export const getUserRegionalPracticeDropdown = () => {
//     return get('RegionalPracticeManagement/GetAllRegionalPracticesDD');
// };

// // Get User Main Practice dropdown (specific to user management)
// export const getUserMainPracticeDropdown = () => {
//     return get('MainPracticeManagement/GetAllMainPracticeDropDowns');
// };
// //-------------------User Management - end------------------//

//-------------------User Management----------------//
// Get all User Management
export const getAllUserManagement = () => {
  return get("RadUser/GetAllRadUser");
};

// delete User Management
export const deleteUserManagement = (RADUserID, modifiedBy) => {
  return post("RadUser/DeleteRadUser", {
    UserID: RADUserID,
    ModifiedBy: modifiedBy,
  });
};

// Get section worklist dropdown
export const getSectionWorklistDropdown = () => {
  return get("RadSection/GetWorkListDropDown");
};

// Save User Management (Add/Update)
export const saveUserManagement = (userData) => {
  return post("RadUser/SaveRadUser", userData);
};

// Activate/Deactivate User Management
export const activateDeactivateUserManagement = (
  userId,
  status,
  modifiedBy,
) => {
  return post("RadUser/ActivateDeactivate", {
    Id: userId,
    Status: status,
    UserId: modifiedBy,
  });
};

// Export User Management to CSV
export const exportUserManagementToCSV = () => {
  return get("RadUser/ExportToCSV");
};

// Update usermanagement
export const getUSerManagementById = (userId, userType = null) => {
  const query = userType
    ? `RadUser/GetRadUserByID?RadUserID=${userId}&UserType=${encodeURIComponent(userType)}`
    : `RadUser/GetRadUserByID?RadUserID=${userId}`;
  return get(query);
};

// Reset MFA for user management
export const resetUserMfa = (userId) => {
  return post("RadUser/ResetMfa", { UserId: userId });
};

//-------------------Holiday Planner - start----------------//
// Get all holiday planner
export const getAllHolidayPlanner = (selectedYear) => {
  if (!selectedYear)
    throw new Error("selectedYear is required for getAllHolidayPlanner");
  return get("Holiday/GetAllHolidays?Year=" + selectedYear);
};

// Save holiday planner
export const saveHolidayPlanner = (holidayPlannerData) => {
  return post("Holiday/SaveHolidayDetails", holidayPlannerData);
};

// Delete holiday planner
export const deleteHolidayPlanner = (
  HolidayID,
  userId,
  year,
  isCurrentYear,
  isFutureYear,
) => {
  if (!year) throw new Error("year is required for deleteHolidayPlanner");
  return post("Holiday/DeleteHoliday", {
    HolidayID: HolidayID,
    CreatedBy: userId,
    Year: year,
    IsHolidayForCurrentYear: isCurrentYear,
    IsHolidayForFutureYear: isFutureYear,
  });
};

// Activate/Deactivate holiday planner
export const activateDeactivateHolidayPlanner = (
  HolidayID,
  status,
  userId,
  year,
  isCurrentYear,
  isFutureYear,
) => {
  if (!year)
    throw new Error("year is required for activateDeactivateHolidayPlanner");
  return post("Holiday/ActivateDeactivate", {
    HolidayID: HolidayID,
    Status: status,
    CreatedBy: userId,
    Year: year,
    IsHolidayForCurrentYear: isCurrentYear,
    IsHolidayForFutureYear: isFutureYear,
  });
};

export const saveHolidayPlannerBulkUpdate = (data) => {
  return post("Holiday/HolidayBulkUpdate", data);
};
//-------------------Holiday Planner - end----------------//

//----- Holiday Demand Planner -------//

export const getAllHolidayDemandPlanner = (payload) => {
  return post("Holiday/GetHolidayCoveragePlanDetails", payload);
};

export const templateDownloadHolidayDemandPlanner = () => {
  return get("Holiday/DownloadHolidayDemandPlannerTemplate");
};

// Bulk save Holiday Demand Planner
export const bulkSaveHolidayDemandPlanner = (payload) => {
  return post("Holiday/HolidayCoveragePlanBulkUpdate", payload);
};

export const fetchHolidayDemandPlannerByRecentYear = (RecentTrendDate) => {
  return get(
    `Holiday/GetHolidayCoveragePlanRecentTrendDetails?RecentTrendDate=${RecentTrendDate}`,
  );
};

export const fetchHolidayDemandPlannerByPastYear = (PastTrendDate) => {
  return get(
    `Holiday/GetHolidayCoveragePlanPastTrendDetails?PastTrendDate=${PastTrendDate}`,
  );
};
export const fetchHolidayDemandPlannerById = (MappingHolidayDateID) => {
  return get(
    `Holiday/GetHolidayDetailsByID?MappingHolidayDateID=${MappingHolidayDateID}`,
  );
};
export const uploadSaveHolidayDemandPlanner = (formData) => {
  return post("Holiday/HolidayCoveragePlanFileUpload", formData);
};
export const logFileDownloadHolidayDemandPlanner = ({
  HolidayCoveragePastTrendFileID,
}) => {
  return get(
    `Holiday/ExportHolidayCoveragePastTrendProcess?HolidayCoveragePastTrendFileID=${HolidayCoveragePastTrendFileID}`,
  );
};
export const dataFileDownloadHolidayDemandPlanner = (HolidayFileName) => {
  return get(
    `Holiday/DownloadHolidayCoverageExamDataFile?HolidayFileName=${HolidayFileName}`,
  );
};

//------------------- Main Practice Start ----------------//
export const GetAllMainPractice = () => {
  return get("MainPracticeManagement/GetAllMainPractices");
};

export const GetAllDropdownList = () => {
  return get("RegionalPracticeManagement/GetAllRegionalPracticesDD");
};

export const SaveMainPractice = (mainPracticeData) => {
  return post("MainPracticeManagement/SaveMainPractice", mainPracticeData);
};

export const GetMainPracticeByID = (payload) => {
  return post("MainPracticeManagement/GetMainPracticesByID", payload);
};

export const deleteMainPractice = (payload) => {
  return post("MainPracticeManagement/DeleteMainPracticeByID", payload);
};

export const ActivateMainPrctice = (payload) => {
  return post("MainPracticeManagement/EnableDisableMainPracticeByID", payload);
};
//-------------------Main Practice end here----------------//
//------------------- Main Practice End ----------------//

//----------Regional Practice Worklist APIs - start----------//
export const getAllRegionalPracticeWorklist = () => {
  return get(
    "RegionalPracticeWorklistManagement/GetAllRegionalPracticesWorklists",
  );
};

export const deleteRegionalPracticeWorklist = (
  RegionalPracticeWorklistID,
  CreatedBy,
) => {
  return post(
    "RegionalPracticeWorklistManagement/DeleteRegionalPracticesWorklistByID",
    {
      RegionalPracticeWorklistID: RegionalPracticeWorklistID,
      CreatedBy: CreatedBy,
    },
  );
};

export const saveRegionalPracticeWorklist = (regionalPracticeWorklistData) => {
  return post(
    "RegionalPracticeWorklistManagement/SaveRegionalPracticeWorklists",
    regionalPracticeWorklistData,
  );
};

export const getRegionalPracticeWorklistById = (
  RegionalPracticeWorklistID,
  modifiedBy,
) => {
  return post(
    "RegionalPracticeWorklistManagement/GetRegionalPracticesWorklistByID",
    {
      RegionalPracticeWorklistID: RegionalPracticeWorklistID,
      CreatedBy: modifiedBy,
    },
  );
};

export const activateDeactivateRegionalPracticeWorklist = (
  RegionalPracticeWorklistID,
  status,
  userId,
) => {
  return post(
    "RegionalPracticeWorklistManagement/EnableDisableRegionalPracticesWorklistByID",
    {
      RegionalPracticeWorklistID: RegionalPracticeWorklistID,
      Status: status,
      CreatedBy: userId,
    },
  );
};

export const getRegionalPracticeDropdown = () => {
  return get("RegionalPracticeManagement/GetAllRegionalPracticesDD");
};
//----------Regional Practice Worklist APIs - end----------//

//---------- Get Regional Practice - Start -----------//
export const getAllRegionalPractice = () => {
  return get("RegionalPracticeManagement/GetAllRegionalPractices");
};

// Delete Regional Practice
export const deleteRegionalPractice = (RegionalPracticeID, CreatedBy) => {
  return post("RegionalPracticeManagement/DeleteRegionalPracticesByID", {
    RegionalPracticeID,
    CreatedBy,
  });
};

// Save Regional Practice (create new regional practice)
export const saveRegionalPractice = (regionalPracticeData) => {
  return post(
    "RegionalPracticeManagement/SaveRegionalPractice",
    regionalPracticeData,
  );
};

// Update Regional Practice
export const getRegionalPracticeById = (regionalPracticeId) => {
  return get(
    `RegionalPracticeManagement/GetRegionalPracticesByID?RegionalPracticeID=${regionalPracticeId}`,
  );
};

// Activate/Deactivate Regional Practice
export const activateDeactivateRegionalPractice = (
  regionalPracticeId,
  status,
  userId,
) => {
  return post("RegionalPracticeManagement/EnableDisableRegionalPracticesByID", {
    RegionalPracticeID: regionalPracticeId,
    Status: status,
    CreatedBy: userId,
  });
};
//---------- Get Regional Practice - End -----------//

//------- WorkList PracticeMode -------//
export const updateWorklistPracticeMode = (workListId, practiceMode) => {
  return post("WorkList/UpdatePracticeMode", {
    WorkListID: workListId,
    PracticeMode: practiceMode,
  });
};
